// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"458":"335f30e0","954":"9859a760","969":"9859a760"}[chunkId] + ".chunk.css";
};